import PageWrapper from "../../components/Page/PageWrapper";
import PageTitle from "../../components/Page/PageTitle";
import RulesTable from "./components/rulesTable/RulesTable";
import RuleActions from "./components/RuleActions";
import { useTranslation } from "react-i18next";

const Rules = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.rules")} />
      <RuleActions />
      <RulesTable />
    </PageWrapper>
  );
};

export default Rules;
